import styled from 'styled-components';
import materialUI from '../../material-UI';

export const List = styled.div`
  display: flex;
  flex-direction: row;
`;
export const Loading = styled(materialUI.CircularProgress)``;
